<template>
<div>
  <el-select v-model="activityType" @change="handleChange">
    <el-option value="" label="不限"></el-option>
    <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label"></el-option>
  </el-select>
  <el-select v-if="activityType" v-model="activityId" @change="handleChangeChild" style="margin-left:8px">
    <el-option value="" label="不限"></el-option>
    <el-option v-for="item in childOptions" :key="item.id" :value="item.id" :label="item.activityName"></el-option>
  </el-select>
</div>
</template>

<script>
import {getActivityList} from '@/api/public.js';
export default {
name: '' ,
components: {},
props:{
  options:{
    type:Array
  },
  form:{
    type:Object,
    default:()=>{
      return {
        activityType:'',
        activityId:'',
      }
    }
  }
},
data() {
return {
  activityType:'',
  activityId:'',
  childOptions:[]
}
},
computed: {},
created() {

},
mounted() {
  console.log('重新开始')
  if(this.form.activityType){
    console.log('执行')
    this.activityType = this.form.activityType;
    getActivityList({activityType:this.activityType}).then(res=>{
      this.childOptions = res.data;
      this.activityId = this.form.activityId;
    })
  }
},
methods: {
  handleChange(){
    this.activityId = "";
    this.$emit('update:form',{...this.form,activityType:this.activityType,activityId:this.activityId})
    getActivityList({activityType:this.activityType}).then(res=>{
      this.childOptions = res.data;
    })
    
  },
  handleChangeChild(){
    this.$emit('update:form',{...this.form,activityType:this.activityType,activityId:this.activityId})
  }
}
}
</script>
<style lang='scss' scoped>

</style>